import {
  ItemPhotoDto,
  ItemThumbnailSize,
} from '@marketplace-web/escrow-pricing/escrow-pricing-data'

export const getPriceBreakdownPhotoThumbnail = (photos: Array<ItemPhotoDto>) => {
  if (!photos) return null

  const photo = photos[0]!
  const thumbnail = photo?.thumbnails?.find(thumb => thumb.type === ItemThumbnailSize.Medium)

  return thumbnail?.url
}
